import React from 'react';

const AqeedahReviews = () => {
    return (
        <div>
            <p>Welcome to aqeedah Reviews</p>
        </div>
    );
};

export default AqeedahReviews;